import React from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";
import './Concepto.scss';
import { useTranslation } from 'react-i18next';

const Concepto = (props) => {
  const { children, titulo1, titulo2 } = props;
  const { t } = useTranslation();

  return (
    <div className='contenedor_concepto'>
      <AnimationOnScroll
        duration={2}
        animateOnce={true}
        animateIn='animate__fadeIn'>
        <div className='titulo_concepto'>
          <h1>{titulo1} <br/> {titulo2}</h1>
        </div>
      </AnimationOnScroll>
      <div className='texto_concepto'>
        {children}
      </div>
      <div className='button_dispo'>
        <a href='/#masterplan'>{t('concepto.availability')}</a>
      </div>
    </div>
  );
}

export default Concepto;
